import type { App, Component } from 'vue'

import { Menu as VMenu } from 'floating-vue'

// WUK Components
import SwordPatientAttentionLevelWuk from '@/components/patient/PatientAttentionLevel.vue'
import SwordButtonWuk from '@ui-kit/components/buttons/SwordButton.vue'
import ChipWuk from '@ui-kit/components/Chip.vue'
import SwordIconWuk from '@ui-kit/components/icons/SwordIcon.vue'
import BaseInputWuk from '@ui-kit/components/inputs/BaseInput.vue'
import SwordPhoneWuk from '@ui-kit/components/inputs/SwordPhone.vue'
import SwordDropdownWuk from '@ui-kit/components/inputs/dropdowns/SwordDropdown.vue'
import SwordFormattedDateWuk from '@ui-kit/components/inputs/date/SwordFormattedDate.vue'
import SwordCheckboxWuk from '@ui-kit/components/inputs/checkboxes/SwordCheckbox.vue'
import SwordCheckboxGroupWuk from '@ui-kit/components/inputs/checkboxes/SwordCheckboxGroup.vue'
import SwordToggleWuk from '@ui-kit/components/inputs/checkboxes/SwordToggle.vue'
import SwordDateWuk from '@ui-kit/components/inputs/date/SwordDate.vue'
import InputErrorWuk from '@ui-kit/components/inputs/footnotes/InputError.vue'
import InputLabelWuk from '@ui-kit/components/inputs/labels/InputLabel.vue'
import MultipleInputEntriesWuk from '@ui-kit/components/inputs/MultipleInputEntries.vue'
import SwordRadioGroupWuk from '@ui-kit/components/inputs/radios/SwordRadioGroup.vue'
import SwordFileUploadWuk from '@ui-kit/components/inputs/SwordFileUpload.vue'
import SwordMeasureWuk from '@ui-kit/components/inputs/SwordMeasure.vue'
import SwordPasswordWuk from '@ui-kit/components/inputs/SwordPassword.vue'
import SwordSearchWuk from '@ui-kit/components/inputs/SwordSearch.vue'
import SwordTextWuk from '@ui-kit/components/inputs/SwordText.vue'
import SwordTextareaWuk from '@ui-kit/components/inputs/SwordTextarea.vue'
import SwordLinkWuk from '@ui-kit/components/links/SwordLink.vue'
import SwordListWuk from '@ui-kit/components/menus/List.vue'
import MenuWuk from '@ui-kit/components/menus/Menu.vue'
import GoalStatusPill from '@ui-kit/components/micro/GoalStatusPill.vue'
import HoverToCopy from '@/components/common/HoverToCopy.vue'
import KitStatusPill from '@ui-kit/components/micro/KitStatusPill.vue'
import TemporaryTransferPill from '@ui-kit/components/micro/TemporaryTransferPill.vue'
import SwordTabWuk from '@ui-kit/components/tab/SwordTab.vue'
import SwordTabGroupWuk from '@ui-kit/components/tab/SwordTabGroup.vue'
import SwordTag from '@/components/common/SwordTag.vue' // Bridge component - Update import & drop proxy after Vue/UI upgrade

// UI Components
import { XTooltip, XPopover, XAlert, XLoader, XAvatar, XDatepicker } from '@swordhealth/ui'

const wukComponents = {
  'SwordLoader': XLoader,
  'SwordIcon': SwordIconWuk,
  'SwordTextWuk': SwordTextWuk,
  'SwordButtonWuk': SwordButtonWuk,
  'ProfilePicture': XAvatar,
  'SwordCheckboxWuk': SwordCheckboxWuk,
  'SwordTag': SwordTag,
  'SwordTooltip': XTooltip,
  'SwordPopoverWuk': XPopover,
  'HoverToCopy': HoverToCopy,
  'SwordDropdownWuk': SwordDropdownWuk,
  'SwordTextareaWuk': SwordTextareaWuk,
  'SwordToggleWuk': SwordToggleWuk,
  'SwordCheckboxGroupWuk': SwordCheckboxGroupWuk,
  'SwordPasswordWuk': SwordPasswordWuk,
  'SwordRadioGroupWuk': SwordRadioGroupWuk,
  'SwordSearchWuk': SwordSearchWuk,
  'SwordPhoneWuk': SwordPhoneWuk,
  'InputLabelWuk': InputLabelWuk,
  'InputErrorWuk': InputErrorWuk,
  'SwordMeasureWuk': SwordMeasureWuk,
  'BaseInputWuk': BaseInputWuk,
  'SwordDateWuk': SwordDateWuk,
  'SwordDate': XDatepicker,
  'SwordFormattedDateWuk': SwordFormattedDateWuk,
  'MultipleInputEntriesWuk': MultipleInputEntriesWuk,
  'SwordFileUploadWuk': SwordFileUploadWuk,
  'SwordAlertWuk': XAlert,
  'ChipWuk': ChipWuk,
  'MenuWuk': MenuWuk,
  'GoalStatusPill': GoalStatusPill,
  'KitStatusPill': KitStatusPill,
  'TemporaryTransferPill': TemporaryTransferPill,
  'SwordPatientAttentionLevelWuk': SwordPatientAttentionLevelWuk,
  'SwordLink': SwordLinkWuk,
  'SwordTabWuk': SwordTabWuk,
  'SwordTabGroupWuk': SwordTabGroupWuk,
  'SwordListWuk': SwordListWuk,
  'VMenu': VMenu,
}

export default {
  install(app: App) {
    Object.entries(wukComponents).forEach(([name, component]) => {
      app.component(name, component as Component)
    })
  },
}
